// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u1-0";
export var checkoutRateBadgeLink = "_u1-1";